"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseAttachedControlsDialogState = exports.ResponsibilityListDataState = exports.ResponsibilityListFilterState = exports.ResponsibilityListState = exports.CausalityListBulkMenuState = exports.ActionListBulkMenuState = exports.ControlListBulkMenuState = exports.RiskListBulkMenuState = exports.EditableListBulkMenuState = exports.CausalityListSettingsState = exports.ActionListSettingsState = exports.CausalityListFilterState = exports.ControlListSettingsState = exports.ActionListFilterState = exports.ControlListFilterState = exports.RiskListFilterState = exports.RiskListSettingsState = exports.CausalityTableListState = exports.ActionTableListState = exports.ControlTableListState = exports.EvaluationDialogState = exports.RiskTableListState = exports.OverviewState = exports.ReferenceDialogState = exports.ObservationDialogState = exports.EditableListDialogState = exports.CausalityDialogState = exports.RiskReviewState = exports.RiskAccordionState = exports.ControlDialogAppState = exports.CatagListState = exports.ControlListState = exports.OwnershipListState = exports.RoleListState = exports.UserListState = exports.ContractState = void 0;
var mobx_1 = require("mobx");
var urls_1 = require("./urls");
var controls_1 = require("./interfaces/controls");
var api_1 = require("./api");
var utils_1 = require("./utils");
var App_1 = require("./App");
var risks_1 = require("./interfaces/risks");
var contexts_1 = require("./interfaces/contexts");
var constants_1 = require("./constants");
var editablelist_1 = require("./interfaces/editablelist");
var columns_1 = require("./components/editableList/columns");
var conversionUtils_1 = require("./interfaces/conversionUtils");
var $ = require("jquery");
var utils_2 = require("./components/editableList/utils");
var utils_3 = require("./components/overview/utils");
var utils_4 = require("./components/references/utils");
var discardRecurrenceDialog_1 = require("./components/controls/discardRecurrenceDialog");
var simulationTab_1 = require("./components/overview/simulationTab");
var ContractState = (function () {
    function ContractState() {
        this.governance = null;
    }
    __decorate([
        mobx_1.observable
    ], ContractState.prototype, "governance", void 0);
    return ContractState;
}());
exports.ContractState = ContractState;
var UserListState = (function () {
    function UserListState() {
        this.users = [];
        this.past_owners = [];
    }
    UserListState.prototype.getUserById = function (id_) {
        return this.users_by_id[id_];
    };
    UserListState.prototype.fetchUsers = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var context, url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    url = (0, urls_1.resolve)(urls_1.Urls.admin_get_users, context.project);
                    this.users = [];
                    this.users_by_id = {};
                    return [2, $.get(url).then(function (response) {
                            console.log(response);
                            _this.users = $.merge([], response.users);
                            _this.users.forEach(function (user) { return _this.users_by_id[user.id] = user; });
                            _this.past_owners = response.past_owners;
                        })];
                }
                else {
                    throw new Error("UserListState does not support the current context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], UserListState.prototype, "users", void 0);
    __decorate([
        mobx_1.observable
    ], UserListState.prototype, "past_owners", void 0);
    __decorate([
        mobx_1.action
    ], UserListState.prototype, "fetchUsers", null);
    return UserListState;
}());
exports.UserListState = UserListState;
var RoleListState = (function () {
    function RoleListState() {
        this.roles = [];
    }
    RoleListState.prototype.fetchRoles = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        this.roles = [];
                        return [4, api_1.api.projects.id(context.project).roles.getAll({})
                                .then(function (page) { return _this.roles = $.merge(_this.roles, page.results); })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2: throw new Error("RoleListState does not support the current context");
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], RoleListState.prototype, "roles", void 0);
    __decorate([
        mobx_1.action
    ], RoleListState.prototype, "fetchRoles", null);
    return RoleListState;
}());
exports.RoleListState = RoleListState;
var OwnershipListState = (function () {
    function OwnershipListState() {
        this.ownerships = [];
        this.risk_status_choices = [];
        this.control_status_choices = [];
        this.action_status_choices = [];
    }
    OwnershipListState.getOwnershipsUrl = function (project_id, user_id) {
        return (0, urls_1.resolve)(urls_1.Urls.edit_ownership_list, project_id, user_id);
    };
    OwnershipListState.getStatusChoicesUrl = function (project_id) {
        return (0, urls_1.resolve)(urls_1.Urls.edit_ownership_status_choices, project_id);
    };
    OwnershipListState.prototype.fetchOwnerships = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.RemappingContext)) return [3, 2];
                        this.ownerships = [];
                        return [4, $.get(OwnershipListState.getOwnershipsUrl(context.project, context.user), function (page) {
                                _this.ownerships = $.merge(_this.ownerships, page.results);
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2: throw new Error("OwnershipListState does not support the current context");
                    case 3: return [2];
                }
            });
        });
    };
    OwnershipListState.prototype.fetchStatusChoices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.RemappingContext)) return [3, 2];
                        this.risk_status_choices = [];
                        this.control_status_choices = [];
                        this.action_status_choices = [];
                        return [4, $.get(OwnershipListState.getStatusChoicesUrl(context.project), function (page) {
                                _this.risk_status_choices = $.merge(_this.risk_status_choices, page.results[0].risks);
                                _this.control_status_choices = $.merge(_this.control_status_choices, page.results[0].controls);
                                _this.action_status_choices = $.merge(_this.action_status_choices, page.results[0].actions);
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2: throw new Error("OwnershipListState does not support the current context");
                    case 3: return [2];
                }
            });
        });
    };
    OwnershipListState.prototype.updateOwnerships = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var context, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.RemappingContext)) return [3, 2];
                        return [4, $.post(OwnershipListState.getOwnershipsUrl(context.project, context.user), JSON.stringify(values))];
                    case 1:
                        result = _a.sent();
                        if (result.success) {
                            notification(gettext("Ownership successfully saved"));
                        }
                        else {
                            notification(gettext(result.error), {
                                type: "error",
                            });
                        }
                        return [3, 3];
                    case 2: throw new Error("OwnershipListState does not support the current context");
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], OwnershipListState.prototype, "ownerships", void 0);
    __decorate([
        mobx_1.observable
    ], OwnershipListState.prototype, "risk_status_choices", void 0);
    __decorate([
        mobx_1.observable
    ], OwnershipListState.prototype, "control_status_choices", void 0);
    __decorate([
        mobx_1.observable
    ], OwnershipListState.prototype, "action_status_choices", void 0);
    __decorate([
        mobx_1.action
    ], OwnershipListState.prototype, "fetchOwnerships", null);
    __decorate([
        mobx_1.action
    ], OwnershipListState.prototype, "fetchStatusChoices", null);
    __decorate([
        mobx_1.action
    ], OwnershipListState.prototype, "updateOwnerships", null);
    return OwnershipListState;
}());
exports.OwnershipListState = OwnershipListState;
var ControlListState = (function () {
    function ControlListState() {
        this.controls = [];
    }
    ControlListState.prototype.fetchControls = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var context, controls_2, promise, controls_3, promise;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    if (isNaN(context.risk))
                        return [2];
                    controls_2 = [];
                    promise = api_1.api.projects.id(context.project).risks.id(context.risk).controls.getAll({})
                        .then(function (page) { return controls_2 = $.merge(controls_2, page.results); }).then(function () { return _this.controls = controls_2; });
                    return [2, promise];
                }
                else if (context instanceof contexts_1.ProjectContext) {
                    controls_3 = [];
                    promise = api_1.api.projects.id(context.project).controls.getAll({})
                        .then(function (page) { return controls_3 = $.merge(controls_3, page.results); }).then(function () { return _this.controls = controls_3; });
                    return [2, promise];
                }
                else {
                    throw new Error("ControlListState does not support the current context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ControlListState.prototype, "controls", void 0);
    __decorate([
        mobx_1.action
    ], ControlListState.prototype, "fetchControls", null);
    return ControlListState;
}());
exports.ControlListState = ControlListState;
var CatagListState = (function () {
    function CatagListState() {
        this.tags = [];
    }
    CatagListState.prototype.fetchProjectCaTags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    this.tags = [];
                    api_1.api.projects.id(project_id).catags.getAll({})
                        .then(function (page) { return _this.tags = $.merge(_this.tags, page.results); });
                }
                else {
                    throw new Error("CatagListState does not support the current context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], CatagListState.prototype, "tags", void 0);
    __decorate([
        mobx_1.action
    ], CatagListState.prototype, "fetchProjectCaTags", null);
    return CatagListState;
}());
exports.CatagListState = CatagListState;
var ControlDialogAppState = (function () {
    function ControlDialogAppState() {
        this.isOpen = false;
        this.isAttaching = false;
        this.control = null;
        this.hasOwnerLeft = false;
        this.recurrence = null;
        this.available_tags = [];
        this.applied_tags = [];
        this.isMandatoryCA = false;
        this.isExclusiveCA = false;
        this.comments = [];
        this.relations = [];
        this.causality_relations = [];
        this.references = [];
        this.entries = [];
        this.selectedTab = 0;
        this.hasDeleteCommentPerm = false;
        this.userProxyId = 0;
        this.controlCosts = [];
        this.availableRiskTargets = [];
        this.udf_types = [];
    }
    ControlDialogAppState.prototype.refresh = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var control, context, project_id, url;
            var _this = this;
            return __generator(this, function (_a) {
                control = this.control;
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    url = control ?
                        (0, urls_1.resolve)(urls_1.Urls.control_dialog_state, project_id, control.id)
                        : (0, urls_1.resolve)(urls_1.Urls.control_dialog_state_no_control, project_id);
                    $.get(url).then(function (state) {
                        if (options && options.only_owners === true) {
                            _this.availableOwners = state.available_owners;
                            return;
                        }
                        else if (options && options.only_control_costs) {
                            _this.controlCosts = state.control_costs;
                            _this.availableRiskTargets = state.available_risk_targets;
                            return;
                        }
                        else if (options && options.only_comments) {
                            _this.comments = state.comments;
                            return;
                        }
                        _this.availableOwners = state.available_owners;
                        _this.control = state.control;
                        _this.hasOwnerLeft = state.has_owner_left;
                        _this.recurrence = state.recurrence;
                        _this.applied_tags = state.applied_tags;
                        _this.available_tags = state.available_tags;
                        _this.isMandatoryCA = state.isMandatoryCA;
                        _this.isExclusiveCA = state.isExclusiveCA;
                        _this.comments = state.comments;
                        _this.relations = state.relations;
                        _this.causality_relations = state.causality_relations;
                        _this.references = state.references;
                        _this.entries = state.entries;
                        _this.availableStatuses = state.available_statuses;
                        _this.availableRecurrence = state.available_recurrence;
                        _this.hasDeleteCommentPerm = state.has_delete_comment_perm;
                        _this.userProxyId = state.user_proxy_id;
                        _this.controlCosts = state.control_costs;
                        _this.availableRiskTargets = state.available_risk_targets;
                        _this.udf_types = state.udf_types;
                    });
                }
                else {
                    throw new Error("Cannot use ControlDialog outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    ControlDialogAppState.prototype.openDialog = function (control) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isOpen = true;
                this.control = control;
                this.recurrence = null;
                this.applied_tags.splice(0, this.applied_tags.length);
                this.comments.splice(0, this.comments.length);
                this.relations.splice(0, this.relations.length);
                this.causality_relations.splice(0, this.causality_relations.length);
                this.references.splice(0, this.references.length);
                this.availableStatuses = [];
                this.availableOwners = [];
                this.availableRecurrence = null;
                this.selectedTab = 0;
                this.refresh();
                return [2];
            });
        });
    };
    ControlDialogAppState.prototype.openDialogForAttachment = function (control) {
        this.isAttaching = true;
        this.openDialog(control);
    };
    ControlDialogAppState.prototype.closeDialog = function () {
        this.control = null;
        this.isOpen = false;
        this.isAttaching = false;
    };
    ControlDialogAppState.prototype.setTab = function (index) {
        this.selectedTab = index;
    };
    ControlDialogAppState.prototype.updateControl = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var control, desiredStatus, data, updated, context, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        control = this.control;
                        desiredStatus = values.status;
                        data = __assign(__assign({}, values), { udf_values: undefined });
                        values.udf_values && values.udf_values.forEach(function (udf) {
                            data["udf_".concat(udf.field_type.id)] = udf.value;
                        });
                        return [4, App_1.store.controllist.updateRows(data)];
                    case 1:
                        _a.sent();
                        return [4, new Promise(function (resolve, reject) {
                                App_1.store.controllist.updateRows(data).then(function (response) {
                                    if (response.discard_recurrence) {
                                        (0, discardRecurrenceDialog_1.discardRecurrenceDialog)({
                                            msg: response.discard_recurrence,
                                            onDiscardAll: function () {
                                                return App_1.store.controllist.updateRows(__assign(__assign({}, data), { remove_recurrence: true, ignore_recurrence_warning: true }));
                                            },
                                            onDiscardOne: function () {
                                                return App_1.store.controllist.updateRows(__assign(__assign({}, data), { ignore_recurrence_warning: true }));
                                            },
                                            width: 500,
                                        }).then(resolve, reject);
                                    }
                                    else {
                                        resolve(true);
                                    }
                                }, reject);
                            })];
                    case 2:
                        updated = _a.sent();
                        if (!updated)
                            return [2, false];
                        context = App_1.store.context.get();
                        if (!(this.isAttaching && context instanceof contexts_1.RiskContext)) return [3, 5];
                        return [4, api_1.api.projects.id(context.project).risks.id(context.risk).riskcontrols.put(control)];
                    case 3:
                        _a.sent();
                        return [4, App_1.store.controls.fetchControls()];
                    case 4:
                        _a.sent();
                        this.control = App_1.store.controls.controls
                            .filter(function (c) { return c.id === control.id; })[0];
                        notification(gettext("Control succesfully attached"));
                        _a.label = 5;
                    case 5:
                        if (this.hasOwnerLeft &&
                            values.assigned_to == this.control.assigned_to &&
                            controls_1.ControlStatusChoices.INCOMPLETE.indexOf(values.status) > -1) {
                            notification(gettext("Owner of Control #" +
                                this.control.control_number +
                                " has left the project and has been removed."), {
                                type: "warning",
                            });
                        }
                        return [4, api_1.api.projects.id(control.project).controls.id(control.id).get()];
                    case 6:
                        result = _a.sent();
                        (0, utils_1.assignAllAttrs)(result, control);
                        notification(gettext("Control succesfully saved"));
                        if (result.status !== desiredStatus) {
                            notification(gettext("Deadline updated to next occurrence"));
                        }
                        this.refresh();
                        App_1.store.controls.fetchControls();
                        return [2, result];
                }
            });
        });
    };
    ControlDialogAppState.prototype.createControl = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var context, tags, control, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        tags = values.tags;
                        delete values.tags;
                        if (values.udf_values == null)
                            delete values.udf_values;
                        return [4, api_1.api.projects.id(context.project).risks.id(context.risk).controls.post(values)];
                    case 1:
                        control = _a.sent();
                        api_1.api.projects.id(control.project).controls.id(control.id).tags.put({
                            tags: tags
                        });
                        if (values.deadline == null) {
                            notification(gettext("No deadline was specified."), { type: 'warning' });
                        }
                        if (values.assigned_to == null) {
                            notification(gettext("No owner was specified."), { type: 'warning' });
                        }
                        notification(gettext("Control succesfully saved"));
                        return [4, App_1.store.controls.fetchControls()];
                    case 2:
                        result = _a.sent();
                        this.control = App_1.store.controls.controls
                            .filter(function (c) { return c.id === control.id; })[0];
                        return [2, result];
                }
            });
        });
    };
    ControlDialogAppState.prototype.saveControlInformation = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.control !== null) {
                    return [2, this.updateControl(values)];
                }
                else {
                    return [2, this.createControl(values)];
                }
                return [2];
            });
        });
    };
    ControlDialogAppState.prototype.saveControlRecurrence = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, api_1.api.projects.id(this.control.project).controls.id(this.control.id).recurrence.put(values)];
                    case 1:
                        result = _a.sent();
                        if (this.recurrence === null) {
                            this.recurrence = result;
                        }
                        else {
                            (0, utils_1.assignAllAttrs)(result, this.recurrence);
                        }
                        notification(gettext("Recurrence succesfully saved"));
                        this.control.deadline = result.control_deadline;
                        this.refresh();
                        App_1.store.controls.fetchControls();
                        return [2, result];
                }
            });
        });
    };
    ControlDialogAppState.prototype.saveComment = function (comment, values) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, api_1.api.projects.id(this.control.project).controls.id(this.control.id).comments.id(comment.id).put(values)];
                    case 1:
                        result = _a.sent();
                        (0, utils_1.assignAllAttrs)(result, comment);
                        notification(gettext("Comment succesfully saved"));
                        return [2];
                }
            });
        });
    };
    ControlDialogAppState.prototype.postComment = function (comment) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, api_1.api.projects.id(this.control.project).controls.id(this.control.id).comments.post(comment)
                        .then(function () {
                        notification(gettext("Comment succesfully created"));
                        _this.refresh({ only_comments: true });
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.deleteComment = function (comment) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, api_1.api.projects.id(this.control.project).controls.id(this.control.id).comments.id(comment.id).delete_()
                        .then(function () {
                        notification(gettext("Comment deleted"));
                        _this.refresh({ only_comments: true });
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.deleteControlRecurrence = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, api_1.api.projects.id(this.control.project).controls.id(this.control.id).recurrence.delete_()
                        .then(function () {
                        notification(gettext("Recurrence disabled"));
                        _this.recurrence = null;
                        _this.refresh();
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.detachRisk = function (risk, retain) {
        if (retain === void 0) { retain = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_control, this.control.project, this.control.id, risk.id), {
                        "make_public": !retain
                    })
                        .then(function () {
                        notification(gettext("Control detached successfully"));
                        var context = App_1.store.context.get();
                        if (context && context instanceof contexts_1.RiskContext && context.risk == risk.id) {
                            App_1.store.controls.fetchControls();
                            _this.refresh();
                        }
                        else {
                            _this.refresh();
                        }
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.detachCausality = function (causality) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_control, this.control.project, this.control.id, causality.id))
                        .then(function () {
                        notification(gettext("Causality detached successfully"));
                        var context = App_1.store.context.get();
                        if (context && context instanceof contexts_1.RiskContext) {
                            App_1.store.controls.fetchControls();
                            _this.refresh();
                        }
                        else {
                            _this.refresh();
                        }
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.checkDetachRisk = function (risk) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, $.get((0, urls_1.resolve)(urls_1.Urls.check_detach_risk_from_control, this.control.project, this.control.id, risk.id))];
            });
        });
    };
    ControlDialogAppState.prototype.deleteControlCost = function (cost_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, api_1.api.projects.id(this.control.project).controls.id(this.control.id).controlCosts.id(cost_id).delete_()
                        .then(function () {
                        notification(gettext("Cost of Control deleted successfully"));
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.postControlCost = function (cost) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, api_1.api.projects.id(this.control.project).controls.id(this.control.id).controlCosts.post(cost)
                        .then(function () {
                        notification(gettext("Control cost successfully created"));
                    })];
            });
        });
    };
    ControlDialogAppState.prototype.updateControlCost = function (cost_id, values) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, api_1.api.projects.id(this.control.project).controls.id(this.control.id).controlCosts.id(cost_id).put(values)
                        .then(function () {
                        notification(gettext("Control cost successfully updated"));
                    })];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "isAttaching", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "control", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "hasOwnerLeft", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "recurrence", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "available_tags", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "applied_tags", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "isMandatoryCA", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "isExclusiveCA", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "comments", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "relations", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "causality_relations", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "references", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "entries", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "availableStatuses", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "availableOwners", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "availableRecurrence", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "selectedTab", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "hasDeleteCommentPerm", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "userProxyId", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "controlCosts", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "availableRiskTargets", void 0);
    __decorate([
        mobx_1.observable
    ], ControlDialogAppState.prototype, "udf_types", void 0);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "refresh", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "openDialogForAttachment", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "setTab", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "updateControl", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "createControl", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "saveControlInformation", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "saveControlRecurrence", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "saveComment", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "postComment", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "deleteComment", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "deleteControlRecurrence", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "detachRisk", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "detachCausality", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "deleteControlCost", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "postControlCost", null);
    __decorate([
        mobx_1.action
    ], ControlDialogAppState.prototype, "updateControlCost", null);
    return ControlDialogAppState;
}());
exports.ControlDialogAppState = ControlDialogAppState;
var RiskAccordionState = (function () {
    function RiskAccordionState() {
        this.elementsToShow = {
            'cause': false,
            'risk': false,
            'effect': false,
            'notes': false,
            'refs': false,
            'review': false
        };
        this.texts = {
            'risk': $("#id_risk").val(),
            'notes': $("#id_notes").val(),
        };
        this.references = [];
        this.causalities = [];
        this.udf_types = [];
        this.udf_values = [];
        var accordionSettings = localStorage.getItem(constants_1.LocalStorageKeys.accordionElements);
        if (accordionSettings !== null) {
            var storageValues = JSON.parse(accordionSettings);
            for (var key in storageValues) {
                var value = storageValues[key];
                this.setElement(key, value);
            }
            this.saveConfiguration();
        }
        else {
            this.setElementShown("risk", true);
        }
    }
    RiskAccordionState.prototype.setElement = function (name, isShown) {
        (0, mobx_1.set)(this.elementsToShow, name, isShown);
    };
    RiskAccordionState.prototype.saveConfiguration = function () {
        var storageValues = {};
        for (var key in this.elementsToShow) {
            var value = this.elementsToShow[key];
            storageValues[key] = value;
        }
        localStorage.setItem(constants_1.LocalStorageKeys.accordionElements, JSON.stringify(storageValues));
    };
    RiskAccordionState.prototype.setElementShown = function (name, isShown) {
        this.setElement(name, isShown);
        this.saveConfiguration();
    };
    RiskAccordionState.prototype.fetchReferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, risk_id, project_id;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    if (isNaN(context.risk))
                        return [2];
                    risk_id = context.risk;
                }
                else {
                    throw new Error("Cannot use RiskAccordion outside of RiskContext");
                }
                project_id = context.project;
                this.references = [];
                return [2, api_1.api.projects.id(project_id).risks.id(risk_id).references.getAll({})
                        .then(function (page) { return _this.references = $.merge(_this.references, page.results); })];
            });
        });
    };
    RiskAccordionState.prototype.fetchCausalities = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, risk_id, project_id;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    if (isNaN(context.risk))
                        return [2];
                    risk_id = context.risk;
                }
                else {
                    throw new Error("Cannot use RiskAccordion outside of RiskContext");
                }
                project_id = context.project;
                this.causalities = [];
                return [2, api_1.api.projects.id(project_id).risks.id(risk_id).causalities.getAll({})
                        .then(function (page) { return _this.causalities = $.merge(_this.causalities, page.results); })];
            });
        });
    };
    RiskAccordionState.prototype.removeCausality = function (causality, retain) {
        if (retain === void 0) { retain = true; }
        return __awaiter(this, void 0, void 0, function () {
            var context, isCause;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        isCause = causality.is_cause;
                        if (!(context instanceof contexts_1.RiskContext)) return [3, 2];
                        return [4, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_causality, context.project, context.risk, causality.id), {
                                "make_public": !retain
                            }).then(function () {
                                if (isCause) {
                                    notification(gettext("Cause successfully removed"));
                                }
                                else {
                                    notification(gettext("Effect successfully removed"));
                                }
                                _this.fetchCausalities();
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2: throw new Error("Cannot use CausalityDialog outside of RiskContext");
                    case 3: return [2];
                }
            });
        });
    };
    RiskAccordionState.prototype.checkDetachCausality = function (causality) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.check_detach_causality, context.project, context.risk, causality.id))];
                }
                else {
                    throw new Error("Cannot use CausalityDialog outside of RiskContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], RiskAccordionState.prototype, "elementsToShow", void 0);
    __decorate([
        mobx_1.observable
    ], RiskAccordionState.prototype, "texts", void 0);
    __decorate([
        mobx_1.observable
    ], RiskAccordionState.prototype, "references", void 0);
    __decorate([
        mobx_1.observable
    ], RiskAccordionState.prototype, "causalities", void 0);
    __decorate([
        mobx_1.observable
    ], RiskAccordionState.prototype, "udf_types", void 0);
    __decorate([
        mobx_1.observable
    ], RiskAccordionState.prototype, "udf_values", void 0);
    __decorate([
        mobx_1.action
    ], RiskAccordionState.prototype, "fetchReferences", null);
    __decorate([
        mobx_1.action
    ], RiskAccordionState.prototype, "fetchCausalities", null);
    __decorate([
        mobx_1.action
    ], RiskAccordionState.prototype, "removeCausality", null);
    return RiskAccordionState;
}());
exports.RiskAccordionState = RiskAccordionState;
var RiskReviewState = (function () {
    function RiskReviewState() {
        this.review = null;
        this.hasPermission = false;
    }
    RiskReviewState.prototype.fetchPermission = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.has_review_permission, context.project))
                            .then(function (page) { _this.hasPermission = page.result; }, function () { _this.hasPermission = false; })];
                }
                else {
                    throw new Error("Cannot use RiskReviewPanel outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    RiskReviewState.prototype.fetchRiskReview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    if (isNaN(context.risk))
                        return [2];
                    return [2, api_1.api.projects.id(context.project).risks.id(context.risk).riskreview.get({}, function (status) { return status == 404; })
                            .then(function (review) { _this.review = review; }, function () { _this.review = null; })];
                }
                else {
                    throw new Error("Cannot use RiskReviewPanel outside of RiskContext");
                }
                return [2];
            });
        });
    };
    RiskReviewState.prototype.updateRiskReview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    return [2, $.post((0, urls_1.resolve)(urls_1.Urls.update_risk_review, context.project, context.risk))];
                }
                else {
                    throw new Error("Cannot use RiskReviewPanel outside of RiskContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], RiskReviewState.prototype, "review", void 0);
    __decorate([
        mobx_1.observable
    ], RiskReviewState.prototype, "hasPermission", void 0);
    __decorate([
        mobx_1.action
    ], RiskReviewState.prototype, "fetchPermission", null);
    __decorate([
        mobx_1.action
    ], RiskReviewState.prototype, "fetchRiskReview", null);
    return RiskReviewState;
}());
exports.RiskReviewState = RiskReviewState;
var CausalityDialogState = (function () {
    function CausalityDialogState() {
        this.isOpen = false;
        this.isCause = true;
        this.causality = null;
        this.causeSearchResults = [];
        this.effectSearchResults = [];
        this.affectedRisks = [];
        this.isSearchingCausalities = false;
        this.latestSearchTerm = "";
    }
    CausalityDialogState.prototype.openDialog = function (causality, isCause) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.causality = causality;
                this.isOpen = true;
                this.isCause = causality ? causality.is_cause : isCause;
                this.affectedRisks = [];
                this.isSearchingCausalities = false;
                this.fetchAffectedRisks(causality);
                return [2];
            });
        });
    };
    CausalityDialogState.prototype.closeDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isSearchingCausalities = false;
                this.causality = null;
                this.isOpen = false;
                return [2];
            });
        });
    };
    CausalityDialogState.prototype.saveCausality = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var context, promise;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    if (this.causality !== null) {
                        promise = api_1.api
                            .projects.id(context.project)
                            .risks.id(context.risk)
                            .causalities.id(this.causality.id).put(values);
                    }
                    else {
                        promise = api_1.api
                            .projects.id(context.project)
                            .risks.id(context.risk)
                            .causalities.post(values);
                    }
                }
                else if (context instanceof contexts_1.ProjectContext) {
                    if (this.causality !== null) {
                        promise = api_1.api
                            .projects.id(context.project)
                            .causalities.id(this.causality.id).put(values);
                    }
                    else {
                        throw new Error("Cannot create causality in ProjectContext");
                    }
                }
                else {
                    throw new Error("Cannot use CausalityDialog outside of ProjectContext");
                }
                return [2, promise.then(function (causality) {
                        _this.closeDialog();
                        if (causality.is_cause) {
                            notification(gettext("Cause successfully saved"));
                        }
                        else {
                            notification(gettext("Effect successfully saved"));
                        }
                    })];
            });
        });
    };
    CausalityDialogState.prototype.search = function (term, isCause, status) {
        if (status === void 0) { status = null; }
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                this.latestSearchTerm = term;
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    if (isNaN(context.risk))
                        return [2];
                    this.isSearchingCausalities = true;
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(context.risk)
                            .attachable_causalities.getAll({
                            text: term,
                            is_cause: isCause,
                            status: status
                        }).then(function (page) {
                            _this.isSearchingCausalities = false;
                            if (_this.isCause) {
                                _this.causeSearchResults = page.results;
                            }
                            else {
                                _this.effectSearchResults = page.results;
                            }
                        }, function (error) {
                            _this.isSearchingCausalities = false;
                        })];
                }
                else {
                    throw new Error("Cannot use CausalityDialog outside of RiskContext");
                }
                return [2];
            });
        });
    };
    CausalityDialogState.prototype.attachCausality = function (causality) {
        return __awaiter(this, void 0, void 0, function () {
            var context, result;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.RiskContext) {
                    result = api_1.api
                        .projects.id(context.project)
                        .risks.id(context.risk)
                        .causalities.post({
                        id: causality.id,
                    });
                    return [2, result.then(function () {
                            _this.closeDialog();
                            _this.search(_this.latestSearchTerm, _this.isCause);
                            if (causality.is_cause) {
                                notification(gettext("Cause successfully attached"));
                            }
                            else {
                                notification(gettext("Effect successfully attached"));
                            }
                        })];
                }
                else {
                    throw new Error("Cannot use CausalityDialog outside of RiskContext");
                }
                return [2];
            });
        });
    };
    CausalityDialogState.prototype.fetchAffectedRisks = function (causality) {
        return __awaiter(this, void 0, void 0, function () {
            var context, result;
            var _this = this;
            return __generator(this, function (_a) {
                if (!causality)
                    return [2];
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    this.isLoadingRisks = true;
                    result = api_1.api
                        .projects.id(context.project)
                        .causalities.id(causality.id)
                        .affected_risks.getAll({});
                    return [2, result.then(function (page) {
                            _this.isLoadingRisks = false;
                            _this.affectedRisks = page.results.map(function (risk) {
                                return {
                                    id: risk.id,
                                    title: risk.title,
                                    number: risk.risk_number,
                                    url: (0, urls_1.resolve)(urls_1.Urls.risk_detail, context.project, risk.id)
                                };
                            });
                        })];
                }
                else {
                    throw new Error("Cannot use CausalityDialog outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "isCause", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "causality", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "causeSearchResults", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "effectSearchResults", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "affectedRisks", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "isLoadingRisks", void 0);
    __decorate([
        mobx_1.observable
    ], CausalityDialogState.prototype, "isSearchingCausalities", void 0);
    __decorate([
        mobx_1.action
    ], CausalityDialogState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], CausalityDialogState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], CausalityDialogState.prototype, "saveCausality", null);
    __decorate([
        mobx_1.action
    ], CausalityDialogState.prototype, "search", null);
    __decorate([
        mobx_1.action
    ], CausalityDialogState.prototype, "attachCausality", null);
    __decorate([
        mobx_1.action
    ], CausalityDialogState.prototype, "fetchAffectedRisks", null);
    return CausalityDialogState;
}());
exports.CausalityDialogState = CausalityDialogState;
var EditableListDialogState = (function () {
    function EditableListDialogState() {
        this.isOpen = false;
        this.isReady = false;
        this.dialogHeader = "";
        this.listProps = {
            rows: [],
            columns: [],
            headers: [],
        };
    }
    EditableListDialogState.prototype.openDialog = function (dialogHeader, listProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isReady = false;
                this.isOpen = true;
                this.dialogHeader = dialogHeader;
                this.listProps = listProps;
                if (listProps && listProps.rows.length > 0) {
                    this.isReady = true;
                }
                return [2];
            });
        });
    };
    EditableListDialogState.prototype.closeDialog = function () {
        this.dialogHeader = "";
        this.listProps = {
            rows: [],
            columns: [],
            headers: [],
        };
        this.isOpen = false;
    };
    __decorate([
        mobx_1.observable
    ], EditableListDialogState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], EditableListDialogState.prototype, "isReady", void 0);
    __decorate([
        mobx_1.observable
    ], EditableListDialogState.prototype, "dialogHeader", void 0);
    __decorate([
        mobx_1.observable
    ], EditableListDialogState.prototype, "listProps", void 0);
    __decorate([
        mobx_1.action
    ], EditableListDialogState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], EditableListDialogState.prototype, "closeDialog", null);
    return EditableListDialogState;
}());
exports.EditableListDialogState = EditableListDialogState;
var ObservationDialogState = (function () {
    function ObservationDialogState() {
        this.isOpen = false;
        this.observation = null;
    }
    ObservationDialogState.prototype.openDialog = function (observation) {
        this.observation = observation;
        this.isOpen = true;
    };
    ObservationDialogState.prototype.closeDialog = function () {
        this.observation = null;
        this.isOpen = false;
    };
    __decorate([
        mobx_1.observable
    ], ObservationDialogState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], ObservationDialogState.prototype, "observation", void 0);
    __decorate([
        mobx_1.action
    ], ObservationDialogState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], ObservationDialogState.prototype, "closeDialog", null);
    return ObservationDialogState;
}());
exports.ObservationDialogState = ObservationDialogState;
var ReferenceDialogState = (function () {
    function ReferenceDialogState() {
        var _a;
        this.isOpen = false;
        this.isReady = false;
        this.reference = null;
        this.searchContext = {
            status_choices: [],
            selected_statuses: [],
            project_choices: [],
            selected_project: null,
        };
        this.search_url_by_type = (_a = {},
            _a[utils_4.ReferenceChoices.TO_RISK] = urls_1.Urls.referencable_risks,
            _a[utils_4.ReferenceChoices.TO_CONTROL] = urls_1.Urls.referencable_controls,
            _a[utils_4.ReferenceChoices.TO_ACTION] = urls_1.Urls.referencable_actions,
            _a);
    }
    ReferenceDialogState.prototype.openDialog = function (reference) {
        return __awaiter(this, void 0, void 0, function () {
            var self;
            return __generator(this, function (_a) {
                this.isReady = false;
                this.resetSearchFilter();
                this.isOpen = true;
                this.reference = reference;
                self = this;
                this.fetchFilterContext().then(function () { return self.isReady = true; });
                return [2];
            });
        });
    };
    ReferenceDialogState.prototype.closeDialog = function () {
        this.reference = null;
        this.isOpen = false;
        this.isReady = false;
        this.resetSearchFilter();
    };
    ReferenceDialogState.prototype.resetSearchFilter = function () {
        this.searchContext = {
            status_choices: [],
            selected_statuses: [],
            project_choices: [],
            selected_project: null,
        };
    };
    ReferenceDialogState.prototype.updateFilter = function (paramName, value) {
        (0, mobx_1.set)(this.searchContext, paramName, value);
    };
    ReferenceDialogState.prototype.updateDialogReference = function (attrName, value) {
        (0, mobx_1.set)(this.reference, attrName, value);
    };
    ReferenceDialogState.prototype.getFormProps = function () {
        return __assign({ reference: this.reference, onSave: this.saveReference.bind(this), onUpdateFilter: this.updateFilter.bind(this), onUpdateDialogReference: this.updateDialogReference.bind(this), fetchSearchResults: this.fetchSearchResults.bind(this) }, this.searchContext);
    };
    ReferenceDialogState.prototype.fetchFilterContext = function () {
        var _this = this;
        var context = App_1.store.context.get();
        if (context instanceof contexts_1.ProjectContext) {
            var url = (0, urls_1.resolve)(urls_1.Urls.reference_dialog_filter_state, context.project, this.reference.id);
            return $.ajax(url, {
                type: "GET",
                contentType: "application/json",
            })
                .fail(function (error) { return console.log(error); })
                .done(function (data) {
                _this.searchContext = data;
            });
        }
        else {
            throw new Error("Cannot use the ReferenceDialog in this context");
        }
    };
    ReferenceDialogState.prototype.saveReference = function () {
        var _this = this;
        var context = App_1.store.context.get();
        if (this.reference && context instanceof contexts_1.ProjectContext) {
            var url = (0, urls_1.resolve)(urls_1.Urls.edit_reference, context.project, this.reference.id);
            var formData = new FormData();
            formData.append('reference_id', this.reference.id.toString());
            formData.append('reference_description', this.reference.description);
            formData.append('reference_type', utils_4.ReferenceChoices.getToLabelNoTranslation(this.reference));
            formData.append('reference_value', (this.reference.to_risk ||
                this.reference.to_control ||
                this.reference.to_action ||
                this.reference.to_link ||
                "null").toString());
            if (this.reference.to_file instanceof File) {
                formData.append("file", this.reference.to_file, this.reference.to_file.name);
            }
            return $.ajax(url, {
                processData: false,
                contentType: false,
                type: 'POST',
                data: formData,
                success: function (response) {
                    notification(gettext("Reference has been successfully changed") + ".");
                    _this.closeDialog();
                },
                error: function (error) {
                    notification(gettext("Error when trying to save reference. Change was not saved."), {
                        type: "error",
                    });
                }
            });
        }
        else {
            throw new Error("Cannot use the ReferenceDialog in this context");
        }
    };
    ReferenceDialogState.prototype.deleteReference = function (reference) {
        return $.post((0, urls_1.resolve)(urls_1.Urls.delete_reference, reference.project, reference.id));
    };
    ReferenceDialogState.prototype.fetchSearchResults = function (text_search) {
        var context = App_1.store.context.get();
        if (context instanceof contexts_1.ProjectContext) {
            var type_ = utils_4.ReferenceChoices.getToType(this.reference);
            var url_name = this.search_url_by_type[type_];
            if (!url_name) {
                throw new Error("Invalid reference type: " + type_.toString());
            }
            var url = (0, urls_1.resolve)(url_name, this.searchContext.selected_project || context.project);
            return $.ajax(url, {
                type: "GET",
                contentType: "application/json",
                data: {
                    "text_search": text_search,
                    "exclude": this.reference.from_risk || this.reference.from_control || this.reference.from_action,
                    "status_list[]": this.searchContext.selected_statuses.map(function (s) { return s; }),
                },
            }).promise().then(function (results) { return results.map(function (r) {
                return { label: r.label, value: r.id.toString() };
            }); });
        }
        else {
            throw new Error("Cannot use the ReferenceDialog in this context");
        }
    };
    __decorate([
        mobx_1.observable
    ], ReferenceDialogState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], ReferenceDialogState.prototype, "isReady", void 0);
    __decorate([
        mobx_1.observable
    ], ReferenceDialogState.prototype, "reference", void 0);
    __decorate([
        mobx_1.observable
    ], ReferenceDialogState.prototype, "searchContext", void 0);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "resetSearchFilter", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "updateFilter", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "updateDialogReference", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "fetchFilterContext", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "saveReference", null);
    __decorate([
        mobx_1.action
    ], ReferenceDialogState.prototype, "fetchSearchResults", null);
    return ReferenceDialogState;
}());
exports.ReferenceDialogState = ReferenceDialogState;
var OverviewState = (function () {
    function OverviewState() {
        this.ownershipTab = new OwnershipTabState();
        this.statusTab = new StatusTabState();
        this.barplotTab = new BarPlotTabState();
        this.valueatriskTab = new ValueAtRiskTabState();
        this.matrixTab = new MatrixTabState();
        this.tagsTab = new OverviewTagsState();
        this.simulationTab = new OverviewSimulationState();
        this.viewOptions = new ViewOptionsState();
    }
    OverviewState.prototype.startLoading = function () {
        this.ownershipTab.setLoading(true);
        this.statusTab.setLoading(true);
        this.barplotTab.setLoading(true);
        this.valueatriskTab.setLoading(true);
        this.matrixTab.setLoading(true);
        this.tagsTab.setLoading(true);
        this.simulationTab.setLoading(true);
    };
    __decorate([
        mobx_1.action
    ], OverviewState.prototype, "startLoading", null);
    return OverviewState;
}());
exports.OverviewState = OverviewState;
var ViewOptionsState = (function () {
    function ViewOptionsState() {
        this.eval_types = ["20"];
        this.number_to_show = "10";
        this.selected_definitions = [];
        this.include_costs = false;
        this.show_quantitative = true;
        this.percentiles = ["50", "60", "75"];
        this.simulations = 100;
        this.simulationDistribution = simulationTab_1.SimulationDistributionChoices.ERLANG;
        this.simulationMatrices = [];
        this.selectedSimulationMatrices = [];
    }
    ViewOptionsState.prototype.fetchOptionsContext = function () {
        var context = App_1.store.context.get();
        var self = this;
        if (!(context instanceof contexts_1.OverviewContext)) {
            throw new Error("Cannot use ViewOptions outside of OverviewContext");
        }
        return $.ajax(urls_1.Urls.overview_options_context, {
            type: "GET",
            contentType: "application/json",
            data: {
                project_group: context.projectGroup,
            }
        }).done(function (response) {
            self.simulationMatrices = response.simulation_matrices;
            self.selectedSimulationMatrices = self.simulationMatrices.map(function (option) { return option.value; });
        });
    };
    ViewOptionsState.prototype.set_simulation_matrices = function (ids) {
        this.selectedSimulationMatrices = ids;
    };
    ViewOptionsState.prototype.set_number_to_show = function (number) {
        this.number_to_show = number;
    };
    ViewOptionsState.prototype.set_eval_types = function (eval_types) {
        this.eval_types = eval_types.slice();
    };
    ViewOptionsState.prototype.set_selected_definition = function (index, selected_definition) {
        this.selected_definitions[index] = selected_definition;
    };
    ViewOptionsState.prototype.set_include_costs = function (include) {
        this.include_costs = include;
    };
    ViewOptionsState.prototype.set_show_quantitative = function (checked) {
        this.show_quantitative = checked;
    };
    ViewOptionsState.prototype.set_percentiles = function (percentiles) {
        this.percentiles = percentiles.slice();
    };
    ViewOptionsState.prototype.set_simulations = function (simulations) {
        this.simulations = simulations;
    };
    ViewOptionsState.prototype.set_distribution = function (distribution) {
        this.simulationDistribution = distribution;
    };
    ViewOptionsState.prototype.get_simulation_options = function () {
        var matrix_ids = this.selectedSimulationMatrices.map(function (m) { return parseInt(m); });
        return {
            simulations: this.simulations,
            distribution: this.simulationDistribution,
            matrices: matrix_ids,
        };
    };
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "eval_types", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "number_to_show", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "selected_definitions", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "include_costs", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "show_quantitative", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "percentiles", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "simulations", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "simulationDistribution", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "simulationMatrices", void 0);
    __decorate([
        mobx_1.observable
    ], ViewOptionsState.prototype, "selectedSimulationMatrices", void 0);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "fetchOptionsContext", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_simulation_matrices", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_number_to_show", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_eval_types", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_selected_definition", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_include_costs", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_show_quantitative", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_percentiles", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_simulations", null);
    __decorate([
        mobx_1.action
    ], ViewOptionsState.prototype, "set_distribution", null);
    return ViewOptionsState;
}());
var LoadingState = (function () {
    function LoadingState() {
        this.isLoading = false;
    }
    LoadingState.prototype.setLoading = function (loading) {
        this.isLoading = loading;
    };
    __decorate([
        mobx_1.observable
    ], LoadingState.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.action
    ], LoadingState.prototype, "setLoading", null);
    return LoadingState;
}());
var StatusTabState = (function (_super) {
    __extends(StatusTabState, _super);
    function StatusTabState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatusTabState.prototype.fetchData = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var context, self, statusPromise, todoPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.OverviewContext)) {
                            throw new Error("Cannot use StatusTab outside of OverviewContext");
                        }
                        self = this;
                        this.isLoading = true;
                        statusPromise = api_1.api.reporting.statuses.post(filters).then(function (result) {
                            self.statuses = {
                                risks: (0, utils_3.convertOverviewColumnsAndRows)(result.risks),
                                controls: (0, utils_3.convertOverviewColumnsAndRows)(result.controls),
                                actions: (0, utils_3.convertOverviewColumnsAndRows)(result.actions),
                                causes: (0, utils_3.convertOverviewColumnsAndRows)(result.causes),
                                effects: (0, utils_3.convertOverviewColumnsAndRows)(result.effects),
                            };
                        });
                        todoPromise = api_1.api.reporting.todos.post(filters).then(function (result) {
                            self.todos = {
                                risks: (0, utils_3.convertOverviewColumnsAndRows)(result.risks),
                                controls: (0, utils_3.convertOverviewColumnsAndRows)(result.controls),
                                actions: (0, utils_3.convertOverviewColumnsAndRows)(result.actions),
                                causes: (0, utils_3.convertOverviewColumnsAndRows)(result.causes),
                                effects: (0, utils_3.convertOverviewColumnsAndRows)(result.effects),
                            };
                        });
                        return [4, Promise.all([statusPromise, todoPromise])];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], StatusTabState.prototype, "statuses", void 0);
    __decorate([
        mobx_1.observable
    ], StatusTabState.prototype, "todos", void 0);
    __decorate([
        mobx_1.action
    ], StatusTabState.prototype, "fetchData", null);
    return StatusTabState;
}(LoadingState));
var BarPlotTabState = (function (_super) {
    __extends(BarPlotTabState, _super);
    function BarPlotTabState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarPlotTabState.prototype.fetchData = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var context, self;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.OverviewContext)) {
                            throw new Error("Cannot use BarPlotTab outside of OverviewContext");
                        }
                        self = this;
                        this.isLoading = true;
                        return [4, api_1.api.reporting.barplots.post(filters).then(function (result) {
                                self.data = {
                                    risks: (0, utils_3.convertOverviewColumnsAndRows)(result.risks),
                                    opportunities: (0, utils_3.convertOverviewColumnsAndRows)(result.opportunities),
                                };
                                self.isLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], BarPlotTabState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], BarPlotTabState.prototype, "fetchData", null);
    return BarPlotTabState;
}(LoadingState));
var ValueAtRiskTabState = (function (_super) {
    __extends(ValueAtRiskTabState, _super);
    function ValueAtRiskTabState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        return _this;
    }
    ValueAtRiskTabState.prototype.fetchData = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var context, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.OverviewContext)) {
                            throw new Error("Cannot use ValueAtRiskTab outside of OverviewContext");
                        }
                        this.isLoading = true;
                        _a = this;
                        return [4, api_1.api.reporting.valueatrisks.post(filters)];
                    case 1:
                        _a.data = _b.sent();
                        this.isLoading = false;
                        return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ValueAtRiskTabState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ValueAtRiskTabState.prototype, "fetchData", null);
    return ValueAtRiskTabState;
}(LoadingState));
var OwnershipTabState = (function (_super) {
    __extends(OwnershipTabState, _super);
    function OwnershipTabState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        return _this;
    }
    OwnershipTabState.prototype.fetchData = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var context, self;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        self = this;
                        if (!(context instanceof contexts_1.OverviewContext)) {
                            throw new Error("Cannot use OwnershipTab outside of OverviewContext");
                        }
                        this.isLoading = true;
                        return [4, api_1.api.reporting.ownership.post(filters).then(function (result) {
                                self.data = (0, utils_3.convertOverviewColumnsAndRows)(result);
                                self.isLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], OwnershipTabState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], OwnershipTabState.prototype, "fetchData", null);
    return OwnershipTabState;
}(LoadingState));
var MatrixTabState = (function (_super) {
    __extends(MatrixTabState, _super);
    function MatrixTabState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        return _this;
    }
    MatrixTabState.prototype.fetchData = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var self, context;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.OverviewContext)) {
                            throw new Error("Cannot use MatrixTab outside of OverviewContext");
                        }
                        this.isLoading = true;
                        return [4, api_1.api.reporting.matrices.post(filters).then(function (result) {
                                self.data = (0, utils_3.convertMatrixTabColumnsAndRows)(result);
                                self.isLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], MatrixTabState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], MatrixTabState.prototype, "fetchData", null);
    return MatrixTabState;
}(LoadingState));
var OverviewTagsState = (function (_super) {
    __extends(OverviewTagsState, _super);
    function OverviewTagsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewTagsState.prototype.fetchData = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var context, self;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        self = this;
                        if (!(context instanceof contexts_1.OverviewContext)) {
                            throw new Error("Cannot use TagsTab outside of OverviewContext");
                        }
                        this.isLoading = true;
                        return [4, api_1.api.reporting.tags.post(filters).then(function (result) {
                                self.data = {
                                    risks: (0, utils_3.convertOverviewColumnsAndRows)(result.risks),
                                    controls: (0, utils_3.convertOverviewColumnsAndRows)(result.controls),
                                    actions: (0, utils_3.convertOverviewColumnsAndRows)(result.actions),
                                };
                                self.isLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], OverviewTagsState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], OverviewTagsState.prototype, "fetchData", null);
    return OverviewTagsState;
}(LoadingState));
var OverviewSimulationState = (function (_super) {
    __extends(OverviewSimulationState, _super);
    function OverviewSimulationState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        return _this;
    }
    OverviewSimulationState.prototype.fetchData = function (filters) {
        var self = this;
        this.isLoading = true;
        return api_1.api.reporting.simulation.post(filters).then(function (result) {
            self.data = result;
            self.isLoading = false;
        });
    };
    OverviewSimulationState.prototype.reloadTab = function () {
        var context = App_1.store.context.get();
        if (!(context instanceof contexts_1.OverviewContext)) {
            throw new Error("Cannot use SimulationTab outside of OverviewContext");
        }
        jQuery("#overview-filter-spinner").hide();
        return this.fetchData({
            filter: (0, App_1.prepareOverviewFilter)(),
            project_group: context.projectGroup,
            opts: App_1.store.overview.viewOptions.get_simulation_options(),
        });
    };
    __decorate([
        mobx_1.observable
    ], OverviewSimulationState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], OverviewSimulationState.prototype, "fetchData", null);
    return OverviewSimulationState;
}(LoadingState));
var RiskTableListState = (function () {
    function RiskTableListState() {
        this.data = {
            columns: [],
            headers: [],
            rows: [],
            ordering: [],
            paginator: {
                leading: [],
                lookahead: 5,
                next: null,
                page: 1,
                page_count: 1,
                page_size: 50,
                previous: null,
                trailing: [],
                items: 0
            },
            read_only: false,
            has_business_model: false,
            bulk_edit_fields: [],
            quick_add_fields: [],
        };
        this.attachableCausalities = [];
        this.has_bim2d = mobx_1.observable.box(false);
        this.project_title = null;
        this.evaluation = new EvaluationDialogState();
        this.settings = new RiskListSettingsState();
        this.bulkMenu = new RiskListBulkMenuState();
        this.filter = new RiskListFilterState();
    }
    RiskTableListState.prototype.updateRows = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    return [2, $.post((0, urls_1.resolve)(urls_1.Urls.risk_list_update, project_id), JSON.stringify(data))];
                }
                else {
                    throw new Error("Cannot use Risks outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.fetchData = function (query_string) {
        return __awaiter(this, void 0, void 0, function () {
            var self, context, project_id, risk_list_url;
            return __generator(this, function (_a) {
                self = this;
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    risk_list_url = (0, urls_1.resolve)(urls_1.Urls.risk_list_data, project_id);
                    if (query_string) {
                        risk_list_url = risk_list_url + query_string;
                    }
                    return [2, $.ajax(risk_list_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            data.columns = data.columns.map(function (column) {
                                return (0, columns_1.dispatchColumn)(column);
                            });
                            data.rows = data.rows.map(function (row) {
                                return (0, utils_2.dispatchRow)(row);
                            });
                            self.data = data;
                            self.has_bim2d.set(data.has_bim2d);
                            self.project_title = data.project_title;
                        })];
                }
                else {
                    throw new Error("Cannot use Risks outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.fetchRowCausalities = function (risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk_id)
                            .causalities.getAll({})
                            .then(function (page) { return page.results; })];
                }
                else {
                    throw new Error("Cannot search for Causalities in this context.");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.fetchAttachableCausalitySuggestions = function (risk_id, searchData) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk_id)
                            .attachable_causalities.getAll(searchData)
                            .then(function (page) { return page.results.map(function (c) { return (0, conversionUtils_1.causalityToSuggestion)(c); }); })];
                }
                else {
                    throw new Error("Cannot search for Causalities in this context.");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.removeCausality = function (causality, risk_id, retain) {
        if (retain === void 0) { retain = true; }
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_causality, context.project, risk_id, causality.id), {
                            "make_public": !retain
                        })];
                }
                else {
                    throw new Error("Cannot remove Causality in this context");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.checkDetachCausality = function (causality, risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.check_detach_causality, context.project, risk_id, causality.id))];
                }
                else {
                    throw new Error("Cannot remove Causality in this context");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.attachCausality = function (causality_id, risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk_id)
                            .causalities.post({
                            id: causality_id,
                        })];
                }
                else {
                    throw new Error("Cannot attach Causality in this context");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.fetchRowControls = function (risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk_id)
                            .controls.getAll({})
                            .then(function (page) { return page.results.map(function (c) { return (0, conversionUtils_1.controlToControlLink)(c); }); })];
                }
                else {
                    throw new Error("Cannot search for Controls in this context.");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.fetchAttachableControlSuggestions = function (risk_id, searchData) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk_id)
                            .attachable_controls.getAll(searchData)
                            .then(function (page) { return page.results.map(function (c) { return (0, conversionUtils_1.controlToSuggestion)(c); }); })];
                }
                else {
                    throw new Error("Cannot search for Controls in this context.");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.removeControl = function (control, risk_id, retain) {
        if (retain === void 0) { retain = true; }
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_control, context.project, control.id, risk_id), {
                            "make_public": !retain
                        })];
                }
                else {
                    throw new Error("Cannot remove Control in this context");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.checkDetachControl = function (control, risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.check_detach_risk_from_control, context.project, control.id, risk_id))];
                }
                else {
                    throw new Error("Cannot detach Risk in this context");
                }
                return [2];
            });
        });
    };
    RiskTableListState.prototype.attachControl = function (control_id, risk_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .controls.id(control_id)
                            .relations.post({
                            id: risk_id,
                        })];
                }
                else {
                    throw new Error("Cannot attach Control in this context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], RiskTableListState.prototype, "data", void 0);
    __decorate([
        mobx_1.observable
    ], RiskTableListState.prototype, "attachableCausalities", void 0);
    __decorate([
        mobx_1.observable
    ], RiskTableListState.prototype, "project_title", void 0);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "updateRows", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "fetchRowCausalities", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "fetchAttachableCausalitySuggestions", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "removeCausality", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "attachCausality", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "fetchRowControls", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "fetchAttachableControlSuggestions", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "removeControl", null);
    __decorate([
        mobx_1.action
    ], RiskTableListState.prototype, "attachControl", null);
    return RiskTableListState;
}());
exports.RiskTableListState = RiskTableListState;
var EvaluationDialogState = (function () {
    function EvaluationDialogState() {
        this.isOpen = false;
        this.risk_id = null;
        this.matrix_id = null;
        this.eval_type = null;
        this.cell_id = null;
        this.matrixData = {
            matrix: {
                id: 0,
                project: 0,
                risk_target: 0,
                risk_target_name: '',
                risk_target_unit: '',
                rows: 0,
                columns: 0,
                is_opportunity: false,
                consequence_display: 0,
                frequency_display: 0,
                explicit_evaluation: false,
                scale_with_budget: false,
                budget: 0,
                risk_reserve: 0,
                frequencies: [],
                consequences: [],
                cells: [],
            },
            evaluations: {}
        };
        this.updateEvaluationCell = null;
    }
    EvaluationDialogState.prototype.setState = function (risk_id, matrix_id, eval_type) {
        this.risk_id = risk_id;
        this.matrix_id = matrix_id;
        this.eval_type = eval_type;
    };
    EvaluationDialogState.prototype.setEtype = function (eval_type) {
        this.eval_type = eval_type;
    };
    EvaluationDialogState.prototype.openDialog = function (evaluation_type, boundEvalCellUpdate) {
        this.isOpen = true;
        this.eval_type = evaluation_type;
        this.updateEvaluationCell = boundEvalCellUpdate || null;
    };
    EvaluationDialogState.prototype.closeDialog = function () {
        this.isOpen = false;
        this.risk_id = null;
        this.matrix_id = null;
        this.eval_type = null;
        this.updateEvaluationCell = null;
    };
    EvaluationDialogState.prototype.updateEvaluation = function (cell_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, set_matrix_evaluation_url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        set_matrix_evaluation_url = (0, urls_1.resolve)(urls_1.Urls.set_risk_evaluation, project_id, this.risk_id);
                        data = {
                            manual_entry: 0,
                            matrix_id: this.matrix_id,
                            cell_id: cell_id,
                            evaluation_type: this.eval_type
                        };
                        return [4, $.post(set_matrix_evaluation_url, $.param(data))
                                .then(function () {
                                notification(gettext("Evaluation updated"));
                            }, function (xhr) {
                                var response = JSON.parse(xhr.responseText);
                                var message = response.message || gettext("Server Error");
                                notification(message, {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot update Evaluation outside of ProjectContext");
                }
            });
        });
    };
    EvaluationDialogState.prototype.fetchEvaluation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, risk_evaluation_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    risk_evaluation_url = (0, urls_1.resolve)(urls_1.Urls.risk_matrix_with_evaluations, context.project, this.matrix_id, this.risk_id);
                    return [2, $.ajax(risk_evaluation_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.matrixData = data;
                            _this.updateEvaluationCell && _this.updateEvaluationCell(data);
                        })];
                }
                else {
                    throw new Error("Cannot fetch Matrix in this context");
                }
                return [2];
            });
        });
    };
    EvaluationDialogState.prototype.updateEstimates = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, set_matrix_evaluation_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        set_matrix_evaluation_url = (0, urls_1.resolve)(urls_1.Urls.set_risk_evaluation, project_id, this.risk_id);
                        data.manual_entry = 1;
                        data.matrix_id = this.matrix_id;
                        data.cell_id = this.cell_id;
                        data.evaluation_type = this.eval_type;
                        return [4, $.post(set_matrix_evaluation_url, $.param(data))
                                .then(function () {
                                notification(gettext("Evaluation updated"));
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot update Evaluation outside of ProjectContext");
                }
            });
        });
    };
    EvaluationDialogState.prototype.get_eval_cell = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, get_eval_cell_url;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        get_eval_cell_url = (0, urls_1.resolve)(urls_1.Urls.risk_evaluated_cell, project_id, this.risk_id);
                        data.matrix = this.matrix_id;
                        return [4, $.post(get_eval_cell_url, $.param(data))
                                .then(function (data) {
                                var json_data = JSON.parse(data);
                                if (json_data.success) {
                                    _this.cell_id = json_data.cell_id;
                                }
                                else {
                                    notification(gettext(json_data.msg), {
                                        type: "error",
                                    });
                                    throw new Error(json_data.msg);
                                }
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot get eval cell outside of ProjectContext");
                }
            });
        });
    };
    EvaluationDialogState.prototype.current_equals_default = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, get_current_equals_default_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        get_current_equals_default_url = (0, urls_1.resolve)(urls_1.Urls.current_evaluation_equals_default, project_id, this.matrix_id, this.risk_id, this.eval_type);
                        return [4, $.get(get_current_equals_default_url)
                                .then(function (data) { return data; }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot get eval cell outside of ProjectContext");
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], EvaluationDialogState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], EvaluationDialogState.prototype, "risk_id", void 0);
    __decorate([
        mobx_1.observable
    ], EvaluationDialogState.prototype, "matrix_id", void 0);
    __decorate([
        mobx_1.observable
    ], EvaluationDialogState.prototype, "eval_type", void 0);
    __decorate([
        mobx_1.observable
    ], EvaluationDialogState.prototype, "cell_id", void 0);
    __decorate([
        mobx_1.observable
    ], EvaluationDialogState.prototype, "matrixData", void 0);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "setState", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "setEtype", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "updateEvaluation", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "fetchEvaluation", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "updateEstimates", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "get_eval_cell", null);
    __decorate([
        mobx_1.action
    ], EvaluationDialogState.prototype, "current_equals_default", null);
    return EvaluationDialogState;
}());
exports.EvaluationDialogState = EvaluationDialogState;
var ControlTableListState = (function () {
    function ControlTableListState() {
        this.isOpen = false;
        this.data = {
            columns: [],
            headers: [],
            rows: [],
            ordering: [],
            paginator: {
                leading: [],
                lookahead: 5,
                next: null,
                page: 1,
                page_count: 1,
                page_size: 50,
                previous: null,
                trailing: [],
                items: 0
            },
            read_only: false,
            has_business_model: false,
            bulk_edit_fields: [],
            quick_add_fields: [],
        };
        this.settings = new ControlListSettingsState();
        this.filter = new ControlListFilterState();
        this.bulkMenu = new ControlListBulkMenuState();
        this.has_bim2d = mobx_1.observable.box(false);
    }
    ControlTableListState.prototype.openDialog = function () {
        this.isOpen = true;
    };
    ControlTableListState.prototype.closeDialog = function () {
        this.isOpen = false;
    };
    ControlTableListState.prototype.updateOrdering = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("Update Control Ordering");
                return [2];
            });
        });
    };
    ControlTableListState.prototype.updateSettings = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        return [4, $.post((0, urls_1.resolve)(urls_1.Urls.control_list_settings, project_id), JSON.stringify(data)).then(function () {
                                notification(gettext("Control list settings successfully saved"));
                            }, function () {
                                notification(gettext("error"), {
                                    type: "error",
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        return [3, 3];
                    case 2: throw new Error("Cannot use Controls outside of ProjectContext");
                    case 3: return [2];
                }
            });
        });
    };
    ControlTableListState.prototype.updateRows = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    return [2, $.post((0, urls_1.resolve)(urls_1.Urls.control_list_update, project_id), JSON.stringify(data))];
                }
                else {
                    throw new Error("Cannot use Controls outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    ControlTableListState.prototype.fetchData = function (query_string) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, control_list_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    control_list_url = (0, urls_1.resolve)(urls_1.Urls.control_list_data, project_id);
                    if (query_string) {
                        control_list_url = control_list_url + query_string;
                    }
                    return [2, $.ajax(control_list_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            data.columns = data.columns.map(function (column) {
                                return (0, columns_1.dispatchColumn)(column);
                            });
                            var rows = [];
                            data.rows.map(function (row) {
                                rows.push((0, utils_2.dispatchRow)(row));
                            });
                            data['rows'] = rows;
                            _this.data = data;
                            _this.has_bim2d.set(data.has_bim2d);
                        })];
                }
                else {
                    throw new Error("Cannot use Controls outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    ControlTableListState.prototype.fetchAttachableRiskSuggestions = function (control_id, searchData) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .controls.id(control_id)
                            .attachableRisks
                            .getAll(searchData)
                            .then(function (page) { return page.results.map(function (r) { return (0, conversionUtils_1.riskToSuggestion)(r); }); })];
                }
                else {
                    throw new Error("Cannot search for Risks in this context.");
                }
                return [2];
            });
        });
    };
    ControlTableListState.prototype.fetchRowRiskRelations = function (control_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .controls.id(control_id)
                            .relations.getAll({})
                            .then(function (page) { return page.results.map(function (r) { return (0, conversionUtils_1.riskToRiskLink)(r); }); })];
                }
                else {
                    throw new Error("Cannot search for Causalities in this context.");
                }
                return [2];
            });
        });
    };
    ControlTableListState.prototype.removeRisk = function (risk, control_id, retain) {
        if (retain === void 0) { retain = true; }
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_control, context.project, control_id, risk.id), {
                            "make_public": !retain
                        })];
                }
                else {
                    throw new Error("Cannot detach Risk in this context");
                }
                return [2];
            });
        });
    };
    ControlTableListState.prototype.checkDetachRisk = function (risk, control_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.check_detach_risk_from_control, context.project, control_id, risk.id))];
                }
                else {
                    throw new Error("Cannot detach Risk in this context");
                }
                return [2];
            });
        });
    };
    ControlTableListState.prototype.attachRisk = function (risk_id, control_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .controls.id(control_id)
                            .relations.post({
                            id: risk_id,
                        })];
                }
                else {
                    throw new Error("Cannot attach Risk in this context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ControlTableListState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], ControlTableListState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "updateOrdering", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "updateSettings", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "updateRows", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "fetchAttachableRiskSuggestions", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "fetchRowRiskRelations", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "removeRisk", null);
    __decorate([
        mobx_1.action
    ], ControlTableListState.prototype, "attachRisk", null);
    return ControlTableListState;
}());
exports.ControlTableListState = ControlTableListState;
var ActionTableListState = (function () {
    function ActionTableListState() {
        this.isOpen = false;
        this.data = {
            columns: [],
            headers: [],
            rows: [],
            ordering: [],
            paginator: {
                leading: [],
                lookahead: 5,
                next: null,
                page: 1,
                page_count: 1,
                page_size: 50,
                previous: null,
                trailing: [],
                items: 0
            },
            read_only: false,
            has_business_model: false,
            bulk_edit_fields: [],
            quick_add_fields: [],
        };
        this.settings = new ActionListSettingsState();
        this.filter = new ActionListFilterState();
        this.bulkMenu = new ActionListBulkMenuState();
    }
    ActionTableListState.prototype.openDialog = function () {
        this.isOpen = true;
    };
    ActionTableListState.prototype.closeDialog = function () {
        this.isOpen = false;
    };
    ActionTableListState.prototype.updateOrdering = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("Update Action Ordering");
                return [2];
            });
        });
    };
    ActionTableListState.prototype.updateSettings = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        project_id = context.project;
                        return [4, $.post((0, urls_1.resolve)(urls_1.Urls.action_list_settings, project_id), JSON.stringify(data)).then(function () {
                                notification(gettext("Action list settings successfully saved"));
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        return [3, 3];
                    case 2: throw new Error("Cannot use Actions outside of ProjectContext");
                    case 3: return [2];
                }
            });
        });
    };
    ActionTableListState.prototype.updateRows = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    return [2, $.post((0, urls_1.resolve)(urls_1.Urls.action_list_update, project_id), JSON.stringify(data))];
                }
                else {
                    throw new Error("Cannot use Actions outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    ActionTableListState.prototype.fetchData = function (query_string) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, action_list_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    action_list_url = (0, urls_1.resolve)(urls_1.Urls.action_list_data, project_id);
                    if (query_string) {
                        action_list_url = action_list_url + query_string;
                    }
                    return [2, $.ajax(action_list_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            data.columns = data.columns.map(function (column) {
                                return (0, columns_1.dispatchColumn)(column);
                            });
                            var rows = [];
                            data.rows.map(function (row) {
                                rows.push((0, utils_2.dispatchRow)(row));
                            });
                            data['rows'] = rows;
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot use Actions outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ActionTableListState.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], ActionTableListState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ActionTableListState.prototype, "openDialog", null);
    __decorate([
        mobx_1.action
    ], ActionTableListState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], ActionTableListState.prototype, "updateOrdering", null);
    __decorate([
        mobx_1.action
    ], ActionTableListState.prototype, "updateSettings", null);
    __decorate([
        mobx_1.action
    ], ActionTableListState.prototype, "updateRows", null);
    __decorate([
        mobx_1.action
    ], ActionTableListState.prototype, "fetchData", null);
    return ActionTableListState;
}());
exports.ActionTableListState = ActionTableListState;
var CausalityPanelState = (function () {
    function CausalityPanelState(is_cause) {
        this.is_cause = true;
        this.data = {
            columns: [],
            headers: [],
            rows: [],
            ordering: [],
            paginator: {
                leading: [],
                lookahead: 5,
                next: null,
                page: 1,
                page_count: 1,
                page_size: 50,
                previous: null,
                trailing: [],
                items: 0
            },
            read_only: false,
            has_business_model: false,
            bulk_edit_fields: [],
            quick_add_fields: [],
        };
        this.settings = null;
        this.filter = null;
        this.is_cause = is_cause;
        this.settings = new CausalityListSettingsState(is_cause);
        this.filter = new CausalityListFilterState(is_cause);
    }
    CausalityPanelState.prototype.getUpdateUrl = function () {
        if (this.is_cause)
            return urls_1.Urls.cause_list_update;
        else
            return urls_1.Urls.effect_list_update;
    };
    CausalityPanelState.prototype.getDataUrl = function () {
        if (this.is_cause)
            return urls_1.Urls.cause_list_data;
        else
            return urls_1.Urls.effect_list_data;
    };
    CausalityPanelState.prototype.updateRows = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    return [2, $.post((0, urls_1.resolve)(this.getUpdateUrl(), project_id), JSON.stringify(data))];
                }
                else {
                    throw new Error("Cannot use Causalities outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    CausalityPanelState.prototype.fetchData = function (query_string) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id, url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    url = (0, urls_1.resolve)(this.getDataUrl(), project_id);
                    if (query_string) {
                        url = url + query_string;
                    }
                    return [2, $.ajax(url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            data.columns = data.columns.map(function (column) {
                                return (0, columns_1.dispatchColumn)(column);
                            });
                            var rows = [];
                            data.rows.map(function (row) {
                                rows.push((0, utils_2.dispatchRow)(row));
                            });
                            data['rows'] = rows;
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot use Causalities outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], CausalityPanelState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], CausalityPanelState.prototype, "updateRows", null);
    __decorate([
        mobx_1.action
    ], CausalityPanelState.prototype, "fetchData", null);
    return CausalityPanelState;
}());
var CausalityTableListState = (function () {
    function CausalityTableListState() {
        this.causes = new CausalityPanelState(true);
        this.effects = new CausalityPanelState(false);
        this.bulkMenu = new CausalityListBulkMenuState();
    }
    CausalityTableListState.prototype.fetchRowRiskRelations = function (causality_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .causalities.id(causality_id)
                            .affected_risks.getAll({})
                            .then(function (page) { return page.results.map(function (r) { return (0, conversionUtils_1.riskToRiskLink)(r); }); })];
                }
                else {
                    throw new Error("Cannot search for Risk relations in this context.");
                }
                return [2];
            });
        });
    };
    CausalityTableListState.prototype.fetchAttachableRiskSuggestions = function (causality_id, searchData) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .causalities.id(causality_id)
                            .attachable_risks.getAll(searchData)
                            .then(function (page) { return page.results.map(function (r) { return (0, conversionUtils_1.riskToSuggestion)(r); }); })];
                }
                else {
                    throw new Error("Cannot search for Risks in this context.");
                }
                return [2];
            });
        });
    };
    CausalityTableListState.prototype.removeRisk = function (risk, causality_id, retain) {
        if (retain === void 0) { retain = true; }
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.detach_risk_from_causality, context.project, risk.id, causality_id), {
                            "make_public": !retain
                        })];
                }
                else {
                    throw new Error("Cannot remove Risk in this context");
                }
                return [2];
            });
        });
    };
    CausalityTableListState.prototype.checkDetachRisk = function (risk, causality_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, $.get((0, urls_1.resolve)(urls_1.Urls.check_detach_causality, context.project, risk.id, causality_id))];
                }
                else {
                    throw new Error("Cannot remove Risk in this context");
                }
                return [2];
            });
        });
    };
    CausalityTableListState.prototype.attachRisk = function (risk_id, causality_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk_id)
                            .causalities.post({
                            id: causality_id,
                        })];
                }
                else {
                    throw new Error("Cannot attach Risk in this context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.action
    ], CausalityTableListState.prototype, "fetchRowRiskRelations", null);
    __decorate([
        mobx_1.action
    ], CausalityTableListState.prototype, "fetchAttachableRiskSuggestions", null);
    __decorate([
        mobx_1.action
    ], CausalityTableListState.prototype, "removeRisk", null);
    __decorate([
        mobx_1.action
    ], CausalityTableListState.prototype, "attachRisk", null);
    return CausalityTableListState;
}());
exports.CausalityTableListState = CausalityTableListState;
var RiskListSettingsState = (function () {
    function RiskListSettingsState() {
        this.data = [];
        this.url = urls_1.Urls.risk_list_settings;
        this.cached_page_size = null;
    }
    RiskListSettingsState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data.data;
                            _this.cached_page_size = data.data.filter(function (d) { return d.name == "page_size"; })[0].value;
                        })];
                }
                else {
                    throw new Error("Cannot fetch RiskListSettings outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    RiskListSettingsState.prototype.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self, search, params, context, settings_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        if (this.cached_page_size && (data.page_size) != this.cached_page_size) {
                            search = new URLSearchParams(window.location.search);
                            search.delete("page");
                            params = "?" + search.toString();
                            window.history.pushState(null, null, window.location.pathname + params);
                        }
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        settings_url = (0, urls_1.resolve)(this.url, context.project);
                        return [4, $.post(settings_url, JSON.stringify(data)).then(function () {
                                self.cached_page_size = (data.page_size);
                                notification(gettext("Risk list settings successfully saved"));
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot update RiskListSettings outside of ProjectContext");
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], RiskListSettingsState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], RiskListSettingsState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], RiskListSettingsState.prototype, "update", null);
    return RiskListSettingsState;
}());
exports.RiskListSettingsState = RiskListSettingsState;
var RiskListFilterState = (function () {
    function RiskListFilterState() {
        this.data = __assign({}, editablelist_1.emptyRiskFilter);
        this.url = urls_1.Urls.risk_list_filter_state;
    }
    RiskListFilterState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot fetch RiskFilterState outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], RiskListFilterState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], RiskListFilterState.prototype, "fetchData", null);
    return RiskListFilterState;
}());
exports.RiskListFilterState = RiskListFilterState;
var ControlListFilterState = (function () {
    function ControlListFilterState() {
        this.data = __assign({}, editablelist_1.emptyControlFilter);
        this.url = urls_1.Urls.control_list_filter_state;
    }
    ControlListFilterState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot fetch ControlFilterState outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ControlListFilterState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ControlListFilterState.prototype, "fetchData", null);
    return ControlListFilterState;
}());
exports.ControlListFilterState = ControlListFilterState;
var ActionListFilterState = (function () {
    function ActionListFilterState() {
        this.data = __assign({}, editablelist_1.emptyActionFilter);
        this.url = urls_1.Urls.action_list_filter_state;
    }
    ActionListFilterState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot fetch ActionFilterState outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ActionListFilterState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ActionListFilterState.prototype, "fetchData", null);
    return ActionListFilterState;
}());
exports.ActionListFilterState = ActionListFilterState;
var ControlListSettingsState = (function () {
    function ControlListSettingsState() {
        this.data = [];
        this.url = urls_1.Urls.control_list_settings;
        this.cached_page_size = null;
    }
    ControlListSettingsState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data.data;
                            _this.cached_page_size = data.data.filter(function (d) { return d.name == "page_size"; })[0].value;
                        })];
                }
                else {
                    throw new Error("Cannot fetch ControlListSettings outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    ControlListSettingsState.prototype.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self, search, params, context, settings_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        if (this.cached_page_size && (data.page_size) != this.cached_page_size) {
                            search = new URLSearchParams(window.location.search);
                            search.delete("page");
                            params = "?" + search.toString();
                            window.history.pushState(null, null, window.location.pathname + params);
                        }
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        settings_url = (0, urls_1.resolve)(this.url, context.project);
                        return [4, $.post(settings_url, JSON.stringify(data)).then(function () {
                                self.cached_page_size = (data.page_size);
                                notification(gettext("Control list settings successfully saved"));
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot update ControlListSettings outside of ProjectContext");
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ControlListSettingsState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ControlListSettingsState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], ControlListSettingsState.prototype, "update", null);
    return ControlListSettingsState;
}());
exports.ControlListSettingsState = ControlListSettingsState;
var CausalityListFilterState = (function () {
    function CausalityListFilterState(is_cause) {
        this.data = __assign({}, editablelist_1.emptyCausalityFilter);
        this.url = null;
        if (is_cause)
            this.url = urls_1.Urls.cause_list_filter_state;
        else
            this.url = urls_1.Urls.effect_list_filter_state;
    }
    CausalityListFilterState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data;
                        })];
                }
                else {
                    throw new Error("Cannot fetch CausalityFilterState outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], CausalityListFilterState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], CausalityListFilterState.prototype, "fetchData", null);
    return CausalityListFilterState;
}());
exports.CausalityListFilterState = CausalityListFilterState;
var ActionListSettingsState = (function () {
    function ActionListSettingsState() {
        this.data = [];
        this.url = urls_1.Urls.action_list_settings;
        this.cached_page_size = null;
    }
    ActionListSettingsState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data.data;
                            _this.cached_page_size = data.data.filter(function (d) { return d.name == "page_size"; })[0].value;
                        })];
                }
                else {
                    throw new Error("Cannot fetch ActionListSettings outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    ActionListSettingsState.prototype.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self, search, params, context, settings_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        if (this.cached_page_size && (data.page_size) != this.cached_page_size) {
                            search = new URLSearchParams(window.location.search);
                            search.delete("page");
                            params = "?" + search.toString();
                            window.history.pushState(null, null, window.location.pathname + params);
                        }
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        settings_url = (0, urls_1.resolve)(this.url, context.project);
                        return [4, $.post(settings_url, JSON.stringify(data)).then(function () {
                                self.cached_page_size = (data.page_size);
                                notification(gettext("Action list settings successfully saved"));
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot update ActionListSettings outside of ProjectContext");
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ActionListSettingsState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], ActionListSettingsState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], ActionListSettingsState.prototype, "update", null);
    return ActionListSettingsState;
}());
exports.ActionListSettingsState = ActionListSettingsState;
var CausalityListSettingsState = (function () {
    function CausalityListSettingsState(is_cause) {
        this.data = [];
        this.cached_page_size = null;
        this.url = null;
        if (is_cause)
            this.url = urls_1.Urls.cause_list_settings;
        else
            this.url = urls_1.Urls.effect_list_settings;
    }
    CausalityListSettingsState.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var context, settings_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    settings_url = (0, urls_1.resolve)(this.url, context.project);
                    return [2, $.ajax(settings_url, {
                            type: "GET",
                            contentType: "application/json"
                        })
                            .fail(function (error) { return console.log(error); })
                            .done(function (data) {
                            _this.data = data.data;
                            _this.cached_page_size = data.data.filter(function (d) { return d.name == "page_size"; })[0].value;
                        })];
                }
                else {
                    throw new Error("Cannot fetch CausalityListSettings outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    CausalityListSettingsState.prototype.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self, search, params, context, settings_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        if (this.cached_page_size && (data.page_size) != this.cached_page_size) {
                            search = new URLSearchParams(window.location.search);
                            search.delete("page");
                            params = "?" + search.toString();
                            window.history.pushState(null, null, window.location.pathname + params);
                        }
                        context = App_1.store.context.get();
                        if (!(context instanceof contexts_1.ProjectContext)) return [3, 2];
                        settings_url = (0, urls_1.resolve)(this.url, context.project);
                        return [4, $.post(settings_url, JSON.stringify(data)).then(function () {
                                self.cached_page_size = (data.page_size);
                                notification(gettext("List settings successfully saved"));
                            }, function () {
                                notification(gettext("Server Error"), {
                                    type: "error",
                                });
                            })];
                    case 1: return [2, _a.sent()];
                    case 2: throw new Error("Cannot update CausalityListSettings outside of ProjectContext");
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], CausalityListSettingsState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], CausalityListSettingsState.prototype, "fetchData", null);
    __decorate([
        mobx_1.action
    ], CausalityListSettingsState.prototype, "update", null);
    return CausalityListSettingsState;
}());
exports.CausalityListSettingsState = CausalityListSettingsState;
var EditableListBulkMenuState = (function () {
    function EditableListBulkMenuState() {
        this.url = "";
        this.data = {
            available_tags: [],
            checked_tags: [],
            unchecked_tags: [],
            available_groups: [],
            checked_groups: [],
            unchecked_groups: [],
            causes: [],
            cause_relations: [],
            effects: [],
            effect_relations: [],
            controls: [],
            control_relations: [],
            risks: [],
            risk_relations: [],
        };
    }
    EditableListBulkMenuState.prototype.fetchData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var context, project_id;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ProjectContext) {
                    project_id = context.project;
                    return [2, $.ajax((0, urls_1.resolve)(this.url, project_id), {
                            type: "GET",
                            data: data,
                            contentType: "application/json"
                        }).then(function (state) {
                            _this.data = state;
                        })];
                }
                else {
                    throw new Error("Cannot use Editable List outside of ProjectContext");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], EditableListBulkMenuState.prototype, "data", void 0);
    __decorate([
        mobx_1.action
    ], EditableListBulkMenuState.prototype, "fetchData", null);
    return EditableListBulkMenuState;
}());
exports.EditableListBulkMenuState = EditableListBulkMenuState;
var RiskListBulkMenuState = (function (_super) {
    __extends(RiskListBulkMenuState, _super);
    function RiskListBulkMenuState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = urls_1.Urls.risk_bulk_edit_state;
        return _this;
    }
    RiskListBulkMenuState.prototype.getFetchDataMethod = function () {
        return _super.prototype.fetchData.bind(this);
    };
    return RiskListBulkMenuState;
}(EditableListBulkMenuState));
exports.RiskListBulkMenuState = RiskListBulkMenuState;
var ControlListBulkMenuState = (function (_super) {
    __extends(ControlListBulkMenuState, _super);
    function ControlListBulkMenuState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = urls_1.Urls.control_bulk_edit_state;
        return _this;
    }
    ControlListBulkMenuState.prototype.getFetchDataMethod = function () {
        return _super.prototype.fetchData.bind(this);
    };
    return ControlListBulkMenuState;
}(EditableListBulkMenuState));
exports.ControlListBulkMenuState = ControlListBulkMenuState;
var ActionListBulkMenuState = (function (_super) {
    __extends(ActionListBulkMenuState, _super);
    function ActionListBulkMenuState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = urls_1.Urls.action_bulk_edit_state;
        return _this;
    }
    ActionListBulkMenuState.prototype.getFetchDataMethod = function () {
        return _super.prototype.fetchData.bind(this);
    };
    return ActionListBulkMenuState;
}(EditableListBulkMenuState));
exports.ActionListBulkMenuState = ActionListBulkMenuState;
var CausalityListBulkMenuState = (function (_super) {
    __extends(CausalityListBulkMenuState, _super);
    function CausalityListBulkMenuState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = urls_1.Urls.causality_list_bulk_menu_state;
        return _this;
    }
    CausalityListBulkMenuState.prototype.getFetchDataMethod = function () {
        return _super.prototype.fetchData.bind(this);
    };
    return CausalityListBulkMenuState;
}(EditableListBulkMenuState));
exports.CausalityListBulkMenuState = CausalityListBulkMenuState;
var ResponsibilityListState = (function () {
    function ResponsibilityListState() {
        this.filter = new ResponsibilityListFilterState();
        this.data = new ResponsibilityListDataState();
    }
    return ResponsibilityListState;
}());
exports.ResponsibilityListState = ResponsibilityListState;
var ResponsibilityListFilterState = (function () {
    function ResponsibilityListFilterState() {
        this.data = {
            status_choices: [],
            risk_owners: [],
            tags: [],
            confidentiality_groups: [],
            matrices: [],
            risk_reviewers: [],
            control_status_choices: [],
            control_owners: [],
            control_tags: [],
            control_costs: [],
            action_status_choices: [],
            action_owners: [],
            action_tags: [],
            users: [],
            selected_users: [],
            projects: null,
            project_groups: null,
            current_group: null,
            current_project: null,
            udf_types: [],
        };
        this.isUpdating = false;
        this.project_url = urls_1.Urls.responsibility_filter_state;
        this.cross_project_url = urls_1.Urls.responsibility_cross_pjt_filter_state;
    }
    ResponsibilityListFilterState.prototype.fetchData = function (query_params) {
        return __awaiter(this, void 0, void 0, function () {
            var context, filter_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                filter_url = "";
                if (context instanceof contexts_1.ProjectContext) {
                    filter_url = (0, urls_1.resolve)(this.project_url, context.project);
                }
                else {
                    filter_url = this.cross_project_url;
                }
                if (query_params) {
                    filter_url = filter_url + query_params;
                }
                this.isUpdating = true;
                return [2, $.ajax(filter_url, {
                        type: "GET",
                        contentType: "application/json"
                    })
                        .fail(function (jqXHR, textStatus, errorThrown) { return api_1.api.apiErrorHandler(jqXHR, textStatus, errorThrown); })
                        .done(function (data) {
                        _this.data = data;
                    })
                        .always(function () {
                        _this.isUpdating = false;
                    })];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ResponsibilityListFilterState.prototype, "data", void 0);
    __decorate([
        mobx_1.observable
    ], ResponsibilityListFilterState.prototype, "isUpdating", void 0);
    __decorate([
        mobx_1.action
    ], ResponsibilityListFilterState.prototype, "fetchData", null);
    return ResponsibilityListFilterState;
}());
exports.ResponsibilityListFilterState = ResponsibilityListFilterState;
var ResponsibilityListDataState = (function () {
    function ResponsibilityListDataState() {
        this.data = [];
        this.isUpdating = false;
        this.project_url = urls_1.Urls.responsibility_data;
        this.cross_project_url = urls_1.Urls.responsibility_cross_pjt_data;
    }
    ResponsibilityListDataState.prototype.fetchData = function (query_params) {
        return __awaiter(this, void 0, void 0, function () {
            var context, filter_url;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                filter_url = "";
                if (context instanceof contexts_1.ProjectContext) {
                    filter_url = (0, urls_1.resolve)(this.project_url, context.project);
                }
                else {
                    filter_url = this.cross_project_url;
                }
                if (query_params) {
                    filter_url = filter_url + query_params;
                }
                this.isUpdating = true;
                return [2, $.ajax(filter_url, {
                        type: "GET",
                        contentType: "application/json"
                    })
                        .fail(function (jqXHR, textStatus, errorThrown) { return api_1.api.apiErrorHandler(jqXHR, textStatus, errorThrown); })
                        .done(function (data) {
                        _this.data = data.results;
                    })
                        .always(function () {
                        _this.isUpdating = false;
                    })];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], ResponsibilityListDataState.prototype, "data", void 0);
    __decorate([
        mobx_1.observable
    ], ResponsibilityListDataState.prototype, "isUpdating", void 0);
    __decorate([
        mobx_1.action
    ], ResponsibilityListDataState.prototype, "fetchData", null);
    return ResponsibilityListDataState;
}());
exports.ResponsibilityListDataState = ResponsibilityListDataState;
var CloseAttachedControlsDialogState = (function () {
    function CloseAttachedControlsDialogState() {
        this.controls = [];
        this.title = gettext("Close attached controls");
    }
    CloseAttachedControlsDialogState.prototype.getChoices = function (status) {
        var choices = [
            { display_name: gettext("Do nothing"), value: null },
            {
                display_name: gettext("Close them"),
                value: controls_1.ControlStatusChoices.DONE.toString(),
                selected: status === risks_1.RiskStatusChoices.CLOSED.toString()
            }, {
                display_name: gettext("Discard them"),
                value: controls_1.ControlStatusChoices.DISCARDED.toString(),
                selected: status === risks_1.RiskStatusChoices.DISCARDED.toString()
            },
        ];
        return choices;
    };
    CloseAttachedControlsDialogState.prototype.closeDialog = function () {
        this.controls = [];
    };
    CloseAttachedControlsDialogState.prototype.fetchAttachedControls = function (riskId) {
        return __awaiter(this, void 0, void 0, function () {
            var context, risk;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                this.controls = [];
                risk = context instanceof contexts_1.RiskContext ? context.risk : riskId;
                if (risk && context instanceof contexts_1.ProjectContext) {
                    return [2, api_1.api
                            .projects.id(context.project)
                            .risks.id(risk)
                            .exclusive_controls.getAll({})
                            .then(function (page) {
                            _this.controls = page.results.map(function (c) { return c; });
                        })];
                }
                else {
                    throw new Error("Cannot fetch controls in the current context");
                }
                return [2];
            });
        });
    };
    CloseAttachedControlsDialogState.prototype.buildMessage = function () {
        if (this.controls) {
            var template = gettext("The following controls attached to the selected risks are still active: %s. " +
                "Do you wish to: ");
            return interpolate(template, [this.controls.map(function (c) { return c.control_number; }).join(", ")]);
        }
        return "";
    };
    CloseAttachedControlsDialogState.prototype.setStatusOnControls = function (status) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.controls) {
                    return [2, App_1.store.controllist.updateRows({
                            controls: this.controls.map(function (c) { return c.id; }),
                            status: status
                        })];
                }
                return [2, new Promise(function () { })];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], CloseAttachedControlsDialogState.prototype, "controls", void 0);
    __decorate([
        mobx_1.action
    ], CloseAttachedControlsDialogState.prototype, "closeDialog", null);
    __decorate([
        mobx_1.action
    ], CloseAttachedControlsDialogState.prototype, "fetchAttachedControls", null);
    return CloseAttachedControlsDialogState;
}());
exports.CloseAttachedControlsDialogState = CloseAttachedControlsDialogState;
